import styled from "styled-components";
import { Link } from "react-router-dom";

// 미디어 쿼리 한번에 어떻게 쓸까?
export const HeaderWrapper = styled.header`
  position: relative;
  width: 100%;
  height: 10rem;
  background-color: rgb(122, 169, 231);
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 4.2rem;
  color: rgb(245, 245, 245);
`;

// styledLink 는 common으로 뺄듯 싶음
export const StyledLink = styled(Link)`
  padding: 1.6rem;
  text-decoration: none;
  color: rgb(245, 245, 245);
  &:visited {
    color: rgb(245, 245, 245);
  }
`;
export const Button = styled.button`
  position: absolute;
  right: 60px;
  width: 9rem;
  height: 3.5rem;
  font-size: 1.8rem;
  background-color: transparent;
  outline: none;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    right: 40px;
  }
`;

export const UserName = styled.span`
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 170px;
  @media screen and (max-width: 768px) {
    right: 140px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
